import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEmployeeDeputeReady} from '../redux/employee_depute'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

import {Employees,Reasons,KitchensScope} from '../../../common/DropDowns/index'

import DateTimeField from "react-bootstrap-datetimepicker";

//import moment from 'moment'

import * as Helpers from '../../../common/helpers'



function filterUnwantedData(employeeData) {
    let data = {}
    if (employeeData && employeeData.data && employeeData.data) {
        data = employeeData.data
    }

    let newData = {}
            newData.id = data.id ? data.id : ""
            newData.name = data.name ? data.name : ""
            newData.email = data.email ? data.email : ""
            newData.code = data.code ? data.code : ""
            newData.mobile = data.mobile ? data.mobile : ""
            newData.status = data.status ? data.status : ""
            newData.status_class = data.status ? data.status.replace(" ","") : ""
            newData.city_name="NA"
            newData.work_location_type=data.work_location_type ? data.work_location_type : "NA"
            newData.work_location="NA"

            if(data.city && data.city.name){
                newData.city_name=data.city.name
            }

            newData.city_id=data.city && data.city.id ? data.city.id : 0

            newData.work_kitchen_id=""

            if(data.kitchen_work_location && data.kitchen_work_location.name && data.work_location_type==="Kitchen"){
                newData.work_location=data.kitchen_work_location.name
                newData.work_kitchen_id=data.kitchen_work_location.id
            }

            if(data.office_work_location && data.office_work_location.name && data.work_location_type!=="Kitchen"){
                newData.work_location=data.office_work_location.name
            }
    
    return newData
}


class AddEmployeeDepute extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",

        employeeData:{},
        employeeDeputeSelectedId:{},

        remarks: "",
        toKitchenId: "",
        reasonId:"",
        approverId: "",
        showEmployeeData:false,

        employeeId:"",
        cityId:0,

        startDate:Helpers.getDateTimeFormatForUTC(new Date()),
        endDate:Helpers.getDateTimeFormatForUTC(new Date()),

        remarksErrorText: false,
        remarksErrorData: '',

        toKitchenIdErrorText: false,
        toKitchenIdErrorData: '',

        employeeIdErrorText: false,
        employeeIdErrorData: '',

        approverIdErrorText: false,
        approverIdErrorData: '',

        reasonIdErrorText: false,
        reasonIdErrorData: '',

        subTitle: Constants.ADD_EMPLOYEE_DEPUTE

    }

    this.isComponentStillMounted = true

    this.remarksComponent = null
    this.remarksSection = null

    this.toKitchenIdComponent = null
    this.toKitchenIdSection = null

    this.employeeIdComponent = null
    this.employeeIdSection = null


    this.approverIdComponent = null
    this.approverIdSection = null

    this.reasonIdComponent = null
    this.reasonIdSection = null

}

componentWillMount() {
    
    this.isComponentStillMounted = true
    this.props.dispatch(addEmployeeDeputeReady(true))
    
    this.props.dispatch(headerDataUpdate(Constants.ADD_EMPLOYEE_DEPUTE))    
    this.props.dispatch(subHeaderDataUpdate())

    this.setState({
            subTitle: "Depute Employee" 
    });
        
    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


}

componentDidMount() {

    
}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    let data = {}

    let yesterdayDate=new Date(Date.now()-(24*60*60*1000));


    let employeeIdObject = this.mandateValidation("employeeId", Constants.FORM_SELECT)
    if (employeeIdObject.status) {
        data.employee_id = this.employeeIdComponent.value
    } else {
        return
    }


    let toKitchenIdObject = this.mandateValidation("toKitchenId", Constants.FORM_SELECT)
    if (toKitchenIdObject.status) {        

        if(parseInt(this.toKitchenIdComponent.value,10)===parseInt(this.state.employeeData.work_kitchen_id,10)){

                        this.dialog.show({
                                title: "Error!!",
                                body: "This employee is already working with 'To Kitchen'",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            return
        }else{
            data.kitchen_id = this.toKitchenIdComponent.value
        }


    } else {
        return
    }

       if(new Date(yesterdayDate)<new Date(this.state.startDate)){
                data.from_datetime=this.state.startDate
            }else{
                 this.dialog.show({
                                title: "Error!!",
                                body: "Start date should be greater than or equals to current date",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            return
            }


       if(new Date(yesterdayDate)<new Date(this.state.endDate)){
                data.to_datetime=this.state.endDate
            }else{
                 this.dialog.show({
                                title: "Error!!",
                                body: "End date should be greater than or equals to current date",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            return
        }

        if(new Date(this.state.endDate).getTime()<=new Date(this.state.startDate).getTime()){
                        this.dialog.show({
                                title: "Error!!",
                                body: "End date should be greater start date",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            return
        }

          if((new Date(this.state.endDate).getTime() - new Date(this.state.startDate).getTime())<7200000){
                        this.dialog.show({
                                title: "Error!!",
                                body: "Start and end range should have to be >=2 Hours",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            return
        }



     let approverIdObject = this.mandateValidation("approverId", Constants.FORM_SELECT)
    if (approverIdObject.status) {
        data.approver_id = this.approverIdComponent.value
    } else {
        return
    }


     let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
    if (reasonIdObject.status) {
        data.reason_id = this.reasonIdComponent.value
    } else {
        return
    }
        
        

    let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
    if (remarksObject.status) {
        data.remarks = this.remarksComponent.value
    } else {
        return
    }



        data.start_date=Helpers.getDateTimeFormatForUTC(data.state_date);
        data.end_date=Helpers.getDateTimeFormatForUTC(data.end_date);

        let apiPayloadData=data;

        let validateTiming={
            "employee_id":data.employee_id,
            "from_date":data.from_datetime,
            "to_date":data.to_datetime

        }

        this.props.dispatch(addEmployeeDeputeReady(false))

        apiService.validateEmployeeDepute(validateTiming)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEmployeeDeputeReady(true))
                        
                        if(responseData.data.length>0){
                              this.dialog.show({
                                title: "Error!!",
                                body: "This employee is already deputed to "+responseData.data[0]['kitchen']['name']+" - "+responseData.data[0]['kitchen']['code']+" from "+Helpers.getDateTimeFormatForUTC(responseData.data[0]['from_datetime'])+" to "+Helpers.getDateTimeFormatForUTC(responseData.data[0]['to_datetime'])+" . Please check.",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

                            this.props.dispatch(addEmployeeDeputeReady(true))
                            return

                        }else{
                            this.addEmployeeDepute(apiPayloadData);
                        }

                    } else {

                        this.props.dispatch(addEmployeeDeputeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEmployeeDeputeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



addEmployeeDepute=(apiPayloadData)=>{

    apiService.addEmployeeDepute(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEmployeeDeputeReady(true))
                        this.props.history.goBack();
                    } else {

                        this.props.dispatch(addEmployeeDeputeReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEmployeeDeputeReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}




getEmployeeById = (id) => {
    this.props.dispatch(addEmployeeDeputeReady(false))
    apiService.getEmployeeById(id)
        .then(responseData => {
            this.props.dispatch(addEmployeeDeputeReady(true))
            if (responseData.status === "SUCCESS") {
                if (responseData && responseData.data) {    
                      let filterData=filterUnwantedData(responseData)
                   
                    this.setState({
                        employeeData: filterData,
                        cityId:filterData.city_id,
                        showEmployeeData:true
                        })


                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEmployeeDeputeReady(true))
        })
}








startDateChange = (newDate) => {
    let startDate=Helpers.getDateTimeFormatForUTC(parseInt(newDate,10));

    this.setState({
        startDate: startDate
    });

}


endDateChange = (newDate) => {

    let endDate=Helpers.getDateTimeFormatForUTC(parseInt(newDate,10));

    this.setState({
        endDate: endDate
    });

}


 kitchenChange = (data) => {
    this.toKitchenIdComponent.value=data.value
        this.setState({
            toKitchenId :data.value,
            toKitchenIdErrorText: false,
            toKitchenIdErrorData: ''
        })
        this.toKitchenIdSection.className= this.toKitchenIdSection.className.replace(" has-error", "")
    }


    employeeChange= (data) => {
    this.employeeIdComponent.value=data.value
        this.setState({
            employeeId :data.value,
            employeeIdErrorText: false,
            employeeIdErrorData: '',
            showEmployeeData:false
        })
        this.employeeIdSection.className= this.employeeIdSection.className.replace(" has-error", "")

        if(data.value!=="" && data.value!==undefined){
            this.setState({
                showEmployeeData:false 
            });
            this.getEmployeeById(data.value)
        }
    }




approverChange = (data) => {
    this.approverIdComponent.value=data.value
        this.setState({
            approverId :data.value,
            approverIdErrorText: false,
            approverIdErrorData: ''
        })
        this.approverIdSection.className= this.approverIdSection.className.replace(" has-error", "")
    }


 reasonChange = (data) => {
    this.reasonIdComponent.value=data.value
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            reasonIdErrorData: ''
        })
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
    }


    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        
                                            <div className="col-md-12 col-sm-12 col-xs-12" style={{zIndex:"4"}}>
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.employeeIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Employee *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.employeeIdComponent = el}>
                                                              <Employees type="ks_list" employeeChange={this.employeeChange} selectedValue={this.state.employeeId} />
                                                              <span className="help-block" style={{ display: this.state.employeeIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.employeeIdErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                     </div>                                          
                                                </div>

                                             {(() => {
                                                if(this.state.showEmployeeData || this.state.editFlag){
                                                    return(

                                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <div className="box-header with-border">
                                                               <h3 className="box-title" style={{ fontWeight: 600 }}>Employee Details</h3>
                                                            </div>
                                                        
                                             <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: "1%"}}>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.code}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.email}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Mobile :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.mobile}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.city_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.work_location}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className={"form-group employee_status_"+this.state.employeeData.status_class+""}>
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                                        <div className="col-sm-7">
                                                               <strong> {this.state.employeeData.status}</strong>
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                                </div>

                                                    </div>

                                                        )
                                                    }
                                            })()} 

                                       

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"3"}}>
                                            <div className="form-group" ref={el => this.toKitchenIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>To Kitchen *</label>
                                                    <div className="col-sm-9" ref={el => this.toKitchenIdComponent = el}>
                                                        
                                                         <KitchensScope type="city_scope" kitchenChange={this.kitchenChange} selectedValue={this.state.toKitchenId} />

                                                        <span className="help-block"style={{display: this.state.toKitchenIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.toKitchenIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">

                                            <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"2"}}>
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Start DateTime *</label>
                                                     <div className="col-sm-9">
                                                        <DateTimeField inputFormat="DD-MMM-YYYY h:mm A" dateTime={new Date(this.state.startDate)} onChange={this.startDateChange}/>
                                                     </div>
                                                  </div>
                                               </div>

                                            </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">

                                            <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"1"}}>
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>End DateTime *</label>
                                                     <div className="col-sm-9">
                                                        <DateTimeField inputFormat="DD-MMM-YYYY h:mm A" dateTime={new Date(this.state.endDate)} onChange={this.endDateChange}/>
                                                     </div>
                                                  </div>
                                               </div>

                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.approverIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Approved By *</label>
                                                    <div className="col-sm-9" ref={el => this.approverIdComponent = el}>
                                                        
                                                         <Employees type="myrm_list" employeeChange={this.approverChange} selectedValue={this.state.approverId} />

                                                        <span className="help-block"style={{display: this.state.approverIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.approverIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.reasonIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                    <div className="col-sm-9" ref={el => this.reasonIdComponent = el}>
                                                       
                                                    <Reasons reasonChange={this.reasonChange} selectedValue={this.state.reasonId} type="EMPLOYEE_DEPUTE" />
                                                        <span className="help-block"style={{display: this.state.reasonIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.reasonIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>




                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Depute Employee
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        employee_depute: state.employee_depute,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEmployeeDepute))


// WEBPACK FOOTER //
// ./src/modules/Employee Depute/Components/AddEmployeeDepute.js